<div class="loader1 dot-spin"></div>

<div class="overlay"></div>
